import { useParams, useRouteMatch } from 'react-router-dom'

import {
  LoadingContainer,
  ModelViewer,
  Modal,
  Panels,
  Bar,
  Select,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'

import { Page } from 'core/components'
import { useTransactionsGetById, useTransactionsUpdate } from 'core/types'

const LoanTransaction = () => {
  const { companyId, personId, loanId, transactionId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
    transactionId?: string
  }>()
  const { url } = useRouteMatch()

  const {
    data: transaction,
    isLoading,
    error,
  } = useTransactionsGetById({
    companyId,
    personId,
    loanId,
    transactionId,
  })

  const { mutateAsync: updateTransaction } = useTransactionsUpdate({
    companyId,
    personId,
    loanId,
    transactionId,
  })

  const name = getName(transaction) || 'Transaction'

  return (
    <Panels
      header={
        <Bar
          right={
            <Modal
              initialValue={transaction}
              onSubmit={async (_updatedTransaction, diff) => {
                await updateTransaction(diff)
              }}
              title='Edit Transaction'
              trigger
            >
              <Select
                formKey='status'
                options={[
                  'scheduled',
                  'initiated',
                  'pending',
                  'succeeded',
                  'failed',
                  'canceled',
                  'inDispute',
                  'chargeback',
                ]}
              />
            </Modal>
          }
          title={name}
        />
      }
    >
      <Breadcrumb title={name} to={url} />
      <LoadingContainer error={error} loading={isLoading}>
        <Page variant='full'>
          <ModelViewer json={transaction} title='Transaction' />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanTransaction
